import { ORG_NAME } from "app/appConfig";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import { getDateTime, getImgLogo, getImgLogoTreamentPrint, getPrintPatientCode, getSystemConfig , hideMiddleDigits } from "app/common/LocalFunction";
import { toVietnamese } from "app/common/utils/VNUtils";
import React, { memo } from "react";

const FormPrintServiecTab = ({ componentRef, dataRegisterService, dataRegisterTreatmentPlan, patient }) => {
    
    return (
        <PrintCommon ref={componentRef} marginPage="8mm" hidden={false}>
            <div className="form-container">
                <div className="logo-header">
                    <div className="logo">
                        {getImgLogoTreamentPrint({ height: "100px", width: "150px" })}
                    </div>
                    <div className="clinic-infos">
                        <strong>  {getSystemConfig("ORG_NAME")}</strong><br />
                        <strong>Hồ sơ thông tin khách hàng</strong>
                    </div>
                    <div className="clinic-infos">
                    </div>
                </div>
                <h3>I. THÔNG TIN CÁ NHÂN</h3>
                <table className="info-table">
                    <tbody>
                        <tr>
                        <td className="dotted-label">
                            <span>Tên khách hàng:</span>
                            <span className="dots">{patient?.patientInfo?.displayName || ''}</span>
                        </td>
                        <td className="dotted-label">
                            <span>Mã khách hàng:</span>
                            <span className="dots">{getPrintPatientCode(patient, patient?.patientInfo)}</span>
                        </td>
                        </tr>

                        <tr>
                        <td className="dotted-label">
                            <span>Số điện thoại:</span>
                            <span className="dots">{hideMiddleDigits(patient?.patientInfo?.phoneNumber) || ''}</span>
                        </td>
                        <td className="dotted-label">
                            <span>Nghề nghiệp:</span>
                            <span className="dots"></span>
                        </td>
                        </tr>

                        <tr>
                        <td className="dotted-label">
                            <span>Ngày sinh:</span>
                            <span className="dots">{patient?.patientInfo?.birthDate 
                            ? new Date(patient.patientInfo.birthDate).toLocaleDateString('vi-VN') 
                            : ''}
                            </span>
                        </td>
                        <td className="dotted-label">
                            <span>Giới tính:</span>
                            <span className="dots">{patient?.patientInfo?.gender === 'F' ? 'Nữ' : 'Nam'}</span>
                        </td>
                        </tr>

                        <tr>
                            <td className="dotted-label full-width" colSpan="2">
                                <span>Nguồn:</span>
                                <span className="dots"></span>
                            </td>
                        </tr>

                        <tr>
                            <td className="dotted-label full-width" colSpan="2">
                                <span>Địa chỉ:</span>
                                <span className="dots">   
                                {[
                                    patient?.patientInfo?.currentWard?.name,
                                    patient?.patientInfo?.currentDistrict?.name,
                                    patient?.patientInfo?.currentProvince?.name
                                ]
                                    .filter(Boolean)
                                    .join(', ')}
                                </span>
                            </td>
                        </tr>

                    </tbody>
                </table>

                <h3>II. THÔNG TIN CHUNG</h3>
                <table  className="info-table">
                    <tbody>
                        <tr>
                            <td className="dotted-label">
                                <span>Chi nhánh:</span>
                                <span className="dots"></span>
                            </td>
                            <td className="dotted-label">
                                <span>Hotline:</span>
                                <span className="dots"></span>
                            </td>
                        </tr>
                        <tr>
                            <td className="dotted-label full-width" colSpan="2">
                                <span>Hạng khách hàng:</span>
                                <span className="dots"></span>
                            </td>
                        </tr>
                        <tr>
                            <td className="dotted-label">
                                <span>Dịch vụ tư vấn gần đây:</span>
                                <span className="dots"></span>
                            </td>
                            <td className="dotted-label">
                                <span>Nhân viên tư vấn:</span>
                                <span className="dots"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3>III. THÔNG TIN DỊCH VỤ</h3>
                <div className="table-responsive">
                    <table className="service-table">
                        <thead>
                            <tr>
                            <th>STT</th>
                            <th>TÊN DỊCH VỤ</th>
                            <th>SL</th>
                            <th>ĐƠN GIÁ (VND)</th>
                            <th>THÀNH TIỀN (CẦN THU)</th>
                            <th>TG ĐĂNG KÝ</th>
                            </tr>
                        </thead>
                             {dataRegisterService?.map((item, index) => (
                                <>
                                    <tbody key={index}>
                                        <tr>
                                        <td>{index + 1}</td>
                                        <td>{item.service?.name || "-"}</td>
                                        <td>{item.quantity || 1}</td>
                                        <td>{item.price?.toLocaleString() || "0"}</td>
                                        <td>{(item.price * item.quantity)?.toLocaleString() || "0"}</td>
                                        <td>{getDateTime(item.orderDate)}</td>
                                        </tr>
                                    </tbody>
                                </>
                            ))}
                            <tfoot>
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center", fontWeight: "bold" }}>
                                    TỔNG TIỀN:
                                    </td>
                                    <td style={{ fontWeight: "bold" }}>
                                    {dataRegisterService?.reduce((sum, item) => {
                                        const price = item.price || 0;
                                        const quantity = item.quantity || 1;
                                        return sum + price * quantity;
                                    }, 0).toLocaleString() || "0"}
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>
                    </table>
                </div>
            </div>
        </PrintCommon>
    );
};

export default memo(FormPrintServiecTab);
